import { render, staticRenderFns } from "./StatusMenu.vue?vue&type=template&id=8f3f5e24&scoped=true&"
import script from "./StatusMenu.vue?vue&type=script&lang=js&"
export * from "./StatusMenu.vue?vue&type=script&lang=js&"
import style0 from "./StatusMenu.vue?vue&type=style&index=0&id=8f3f5e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3f5e24",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f3f5e24')) {
      api.createRecord('8f3f5e24', component.options)
    } else {
      api.reload('8f3f5e24', component.options)
    }
    module.hot.accept("./StatusMenu.vue?vue&type=template&id=8f3f5e24&scoped=true&", function () {
      api.rerender('8f3f5e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/StatusMenu.vue"
export default component.exports